class r {
  constructor() {
  }
  validate(t) {
    return !!t;
  }
}
export {
  r as default
};
